import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { displayNullable } from '../../../types';
import { styled } from '../../../utils';
import { Chip } from '../../Chip';
import { FormHelperText } from '../../Form';
import { Skeleton } from '../../Skeleton';
import { Typography } from '../../Typography';
export function CardRow({ label, value, isBoolean, className, error, helperText, alignItems = 'center', flexWrap = 'wrap', flex, }) {
    return (_jsxs(RowRoot, { alignItems: alignItems, flexWrap: flexWrap, className: className, children: [_jsxs(CardColumnOne, { value: value, flex: flex, children: [_jsx(Typography, { variant: "body1", component: "span", color: error ? 'error' : undefined, children: label }), error && helperText && (_jsx(FormHelperText, { error: true, children: helperText }))] }), value && (_jsx(CardColumnTwo, { children: isBoolean !== undefined ? (_jsx(CardChip, { isBoolean: isBoolean, label: value, clickable: false, size: "small" })) : (_jsx(Typography, { variant: "body1", component: "span", color: "inherit", children: displayNullable(value) })) }))] }));
}
const RowRoot = styled('div', {
    shouldForwardProp: (prop) => prop !== 'alignItems' && prop !== 'flexWrap',
    name: 'CardRowRoot',
})(({ theme, alignItems, flexWrap }) => ({
    display: 'flex',
    flexWrap,
    justifyContent: 'space-between',
    alignItems,
    padding: theme.spacing(0.5, 0),
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
    '&:last-of-type': {
        borderBottom: '0 none',
    },
}));
const CardColumnOne = styled('div', {
    shouldForwardProp: (prop) => prop !== 'value' && prop !== 'flex',
    name: 'CardColumnOne',
})(({ theme, value, flex }) => ({
    flex: flex ?? (value ? '0 0 40%' : '1 1 100%'),
    paddingRight: value ? theme.spacing(4) : '',
}));
const CardColumnTwo = styled('div', {
    name: 'CardColumnTwo',
})(({ theme }) => ({
    color: theme.palette.primary.dark,
    marginLeft: 'auto',
    flex: '1 1 25%',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
        marginLeft: '0',
    },
}));
const CardChip = styled((props) => _jsx(Chip, { ...props }), {
    shouldForwardProp: (prop) => prop !== 'isBoolean',
    name: 'CardChip',
})(({ theme, isBoolean }) => ({
    backgroundColor: isBoolean
        ? theme.palette.success.light
        : theme.palette.error.main,
    color: 'white',
    padding: theme.spacing(0, 2),
}));
export function CardTwoColumnRowSkeleton() {
    return (_jsx(RowRoot, { alignItems: "center", children: _jsx(CardColumnOne, { children: _jsx(Skeleton, { variant: "text", height: 24 }) }) }));
}
